import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError, tap } from 'rxjs/operators'
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreditActivityService } from './credit-activity.service';
const devUrl = environment.backendurl;

@Injectable({
  providedIn: 'root'
})
export class WebbtreeVerifiedService {

  constructor(private http: HttpClient, private creditActivityService: CreditActivityService) { }

  getRequestContract(requestObject: any): Observable<any> {
    let url = devUrl + "/personsearch/premiumenrichment";
    return this.http.post<any>(url, requestObject).pipe(
      map(response => { return response; }),
      // Notify on every response, not just status === 'success' - a 200 response with
      // status !== 'success' (e.g. "not enough credits") still needs a refresh so the UI shows
      // the real current balance, and catchError below covers actual HTTP-level failures.
      tap((res: any) => { this.creditActivityService.notifyCreditConsumed(); }),
      catchError((err: any) => {
        this.creditActivityService.notifyCreditConsumed();
        return GlobalService.handleError('Error while making contract request', url)(err);
      }));
  }

}
